/* ==========================================================================
   DRIED FOODS — slide-out cart

   Every add-to-cart on the site is intercepted, added through the Cart AJAX
   API, and the drawer slides open. No page navigation.

   The drawer body is rendered here from /cart.js rather than through the
   Section Rendering API, so this works wherever the markup is rendered and
   needs no theme.liquid edit.
   ========================================================================== */
(function () {
  'use strict';

  // The header can render more than once (theme editor); binding twice would
  // fire two add requests per click.
  if (window.driedCartReady) return;
  window.driedCartReady = true;

  var busy = false;

  /* Turn on with ?driedcart=debug in the URL, or driedCartDebug = true in the
     console. Logs each step and reports anything that tries to leave the page
     after an add, which is the usual sign another script is sending the
     shopper to /cart. */
  var DEBUG = /[?&]driedcart=debug/.test(location.search) || window.driedCartDebug === true;
  function log() {
    if (!DEBUG || !window.console) return;
    var args = ['[dried-cart]'].concat([].slice.call(arguments));
    console.log.apply(console, args);
  }
  if (DEBUG) {
    window.addEventListener('beforeunload', function () {
      log('PAGE IS NAVIGATING — something outside this script triggered it');
    });
    log('ready');
  }

  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function overlay() { return document.querySelector('.dried-minicart-overlay'); }
  function conf(name, fallback) {
    var d = drawer();
    var v = d && d.getAttribute('data-' + name);
    return v || fallback;
  }

  /* ---------- money ---------- */

  // Mirrors Shopify's formatMoney for the money_format strings a shop can use.
  function formatMoney(cents) {
    var format = conf('money-format', '{{amount}}');
    var value = '';

    function num(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) n = 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';

    switch (kind) {
      case 'amount': value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      default: value = num(cents, 2, ',', '.');
    }
    // A format with no placeholder would otherwise drop the number entirely
    if (!match) return value + ' ' + format.trim();
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- open / close ---------- */

  var primed = false;
  function open() {
    var d = drawer(), o = overlay();
    if (!d || !o) return;
    if (!primed) { primed = true; loadCart(); }   // fills "You may also like" on first open
    o.removeAttribute('hidden');
    requestAnimationFrame(function () {   // next frame so the transition runs
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var d = drawer(), o = overlay();
    if (!d || !o) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { o.setAttribute('hidden', ''); }, 400);
  }

  /* ---------- render ---------- */

  function render(cart) {
    var d = drawer();
    if (!d) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    var body = d.querySelector('[data-cart-body]');
    var foot = d.querySelector('[data-cart-foot]');
    if (!body) return;

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="dried-minicart__empty">' + esc(conf('empty-text', 'Your cart is empty.')) + '</p>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }

    body.innerHTML = '<ul class="dried-minicart__items">' + cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="dried-minicart__variant">' + esc(item.variant_title) + '</div>' : '';

      return '<li class="dried-minicart__item" data-key="' + esc(item.key) + '">'
        + '<a href="' + esc(item.url) + '" class="dried-minicart__thumb">' + img + '</a>'
        + '<div class="dried-minicart__info">'
        + '<a href="' + esc(item.url) + '" class="dried-minicart__name">' + esc(item.product_title) + '</a>'
        + variant
        + '<div class="dried-minicart__qty">'
        + '<button type="button" class="dried-minicart__qty-btn" data-cart-qty="-1" aria-label="Decrease quantity">-</button>'
        + '<input type="number" class="dried-minicart__qty-input" value="' + item.quantity + '" min="0" step="1" inputmode="numeric" aria-label="Quantity" data-cart-qty-input>'
        + '<button type="button" class="dried-minicart__qty-btn" data-cart-qty="1" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '<div class="dried-minicart__line">' + item.quantity + ' &times; ' + formatMoney(item.final_price) + '</div>'
        + '</div>'
        + '<button type="button" class="dried-minicart__remove" data-cart-remove aria-label="Remove">&times;</button>'
        + '</li>';
    }).join('') + '</ul>';

    if (foot) {
      foot.removeAttribute('hidden');
      var sub = foot.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
  }

  /* ---------- "You may also like" ----------
     Shopify's Product Recommendations API returns the same recommendations the
     Search & Discovery app manages. We ask about the most recent line, drop
     anything already in the cart, and show the rest with an Add button. */

  var recsFor = null;   // product id the current list was built for
  var recsCache = {};   // product id -> products, so quantity edits don't refetch

  function sizedImage(url, size) {
    // Shopify CDN URLs accept a _WxH suffix before the extension
    return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2') : '';
  }

  function renderRecs(products) {
    var d = drawer();
    var wrap = d && d.querySelector('[data-cart-recs]');
    var list = d && d.querySelector('[data-cart-recs-list]');
    if (!wrap || !list) return;

    if (!products || !products.length) {
      wrap.setAttribute('hidden', '');
      list.innerHTML = '';
      return;
    }

    var addText = conf('recs-add-text', 'Add');
    list.innerHTML = products.map(function (p) {
      var variant = (p.variants || []).filter(function (v) { return v.available; })[0];
      var img = p.featured_image ? '<img src="' + esc(sizedImage(p.featured_image, '300x300')) + '" alt="" loading="lazy">' : '';
      var price = formatMoney(variant ? variant.price : p.price);
      var button = variant
        ? '<button type="button" class="dried-minicart__rec-add" data-rec-add="' + variant.id + '">' + esc(addText) + '</button>'
        : '';
      return '<li class="dried-minicart__rec">'
        + '<a href="' + esc(p.url) + '" class="dried-minicart__rec-img">' + img + '</a>'
        + '<a href="' + esc(p.url) + '" class="dried-minicart__rec-name">' + esc(p.title) + '</a>'
        + '<div class="dried-minicart__rec-row">'
        + '<span class="dried-minicart__rec-price">' + price + '</span>' + button
        + '</div></li>';
    }).join('');
    wrap.removeAttribute('hidden');
    list.scrollLeft = 0;
    syncRecsArrows();
  }

  /* Slider arrows: scroll by one card; grey out at either end. */
  function recsList() { var d = drawer(); return d && d.querySelector('[data-cart-recs-list]'); }
  function syncRecsArrows() {
    var list = recsList(), d = drawer();
    if (!list || !d) return;
    var prev = d.querySelector('[data-recs-prev]'), next = d.querySelector('[data-recs-next]');
    var max = list.scrollWidth - list.clientWidth;
    if (prev) prev.disabled = list.scrollLeft <= 1;
    if (next) next.disabled = list.scrollLeft >= max - 1;
  }
  function scrollRecs(dir) {
    var list = recsList();
    if (!list) return;
    var card = list.querySelector('.dried-minicart__rec');
    var step = card ? card.getBoundingClientRect().width + 10 : 150;   // card + gap
    list.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function loadRecs(cart) {
    var d = drawer();
    if (!d || conf('recs', '1') === '0') return;

    if (!cart.items || !cart.items.length) { renderRecs([]); recsFor = null; return; }

    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });

    var seed = cart.items[0].product_id;   // items[0] is the most recently added
    var limit = parseInt(conf('recs-limit', '4'), 10) || 4;
    var intent = conf('recs-intent', 'related');

    var show = function (all) {
      var picks = all.filter(function (p) {
        if (inCart[p.id]) return false;
        return (p.variants || []).some(function (v) { return v.available; });   // nothing to add otherwise
      }).slice(0, limit);
      renderRecs(picks);
    };

    if (recsCache[seed]) { recsFor = seed; show(recsCache[seed]); return; }

    var url = '/recommendations/products.json?product_id=' + seed + '&limit=' + (limit + 4) + '&intent=' + intent;
    log('fetching recommendations', url);
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var products = (data && data.products) || [];
        // Complementary needs pairings set up in Search & Discovery; without
        // any, fall back to Related so the block is not empty.
        if (!products.length && intent === 'complementary') {
          return fetch(url.replace('intent=complementary', 'intent=related'))
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (d2) { return (d2 && d2.products) || []; });
        }
        return products;
      })
      .then(function (products) {
        recsCache[seed] = products;
        recsFor = seed;
        show(products);
      })
      .catch(function (err) { log('recommendations failed', err); renderRecs([]); });
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        log('cart loaded', cart.item_count, 'items');
        render(cart);
        loadRecs(cart);
        return cart;
      });
  }

  /* ---------- actions ---------- */

  function addToCart(form) {
    if (busy) return;
    busy = true;

    var btn = form.querySelector('[type="submit"]:not([data-buy-now])');
    if (btn) btn.disabled = true;

    // Tracks whether the item actually reached the cart. Once it has, we never
    // navigate: a native form.submit() here is a plain POST that Shopify answers
    // with a redirect to /cart, which is exactly what we are avoiding. So the
    // fallback is scoped to the add request itself — anything that goes wrong
    // afterwards (rendering, opening) is logged, not escalated to a page load.
    var added = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (body) {
          throw { addFailed: true, body: body };
        }, function () {
          throw { addFailed: true };
        });
        added = true;
        return r.json().catch(function () { return {}; });
      })
      .then(function () { return loadCart(); })
      .then(function () { open(); })
      .catch(function (err) {
        if (!added && err && err.addFailed) {
          // The add genuinely failed (sold out, variant gone). Let the browser
          // post the form so the shopper sees Shopify's own message.
          log('add failed, falling back to a normal post', err.body);
          form.submit();
          return;
        }
        // Item is in the cart. Show the drawer with whatever we have.
        log('added, but refreshing the drawer failed', err);
        try { open(); } catch (e) {}
      })
      .finally(function () {
        busy = false;
        if (btn) btn.disabled = false;
      });
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;

    var d = drawer();
    if (d) d.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); loadRecs(cart); })
      .catch(function () {})
      .finally(function () {
        busy = false;
        if (d) d.classList.remove('is-loading');
      });
  }

  /* ---------- wiring ---------- */

  // Shopify renders action="/cart/add", or "/<locale>/cart/add" on multi-market shops
  function cartForm(el) {
    if (!el || !el.closest) return null;
    var form = el.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-drawer')) return null;
    return form;
  }

  /* Capture phase, and the event is stopped dead.

     A bubble-phase listener on document runs *after* any handler the theme has
     bound to the form itself, and those normally send the shopper to /cart —
     which is why the drawer would open and the page would navigate anyway.
     Capturing on document arrives first; stopImmediatePropagation keeps the
     event from reaching anything else. */
  document.addEventListener('submit', function (e) {
    var form = cartForm(e.target);
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    log('intercepted submit', form.getAttribute('action'));
    addToCart(form);
  }, true);

  // Some themes bind the click on the button rather than the form's submit.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"], input[type="submit"], [name="add"]');
    if (!btn) return;
    if (btn.hasAttribute('data-buy-now') || btn.closest('[data-buy-now]')) return;  // Buy now goes to checkout
    var form = cartForm(btn);
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    log('intercepted click on add button');
    addToCart(form);
  }, true);

  function addVariant(variantId, btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(loadCart)
      .catch(function (err) { log('add from recommendation failed', err); })
      .finally(function () { busy = false; if (btn) btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }

    var rec = e.target.closest('[data-rec-add]');
    if (rec) { e.preventDefault(); addVariant(rec.getAttribute('data-rec-add'), rec); return; }

    if (e.target.closest('[data-recs-prev]')) { e.preventDefault(); scrollRecs(-1); return; }
    if (e.target.closest('[data-recs-next]')) { e.preventDefault(); scrollRecs(1); return; }

    var item = e.target.closest('.dried-minicart__item');
    if (!item) return;

    var step = e.target.closest('[data-cart-qty]');
    if (step) {
      e.preventDefault();
      var input = item.querySelector('[data-cart-qty-input]');
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cart-qty'), 10);
      changeLine(item.getAttribute('data-key'), next < 0 ? 0 : next);
      return;
    }
    if (e.target.closest('[data-cart-remove]')) {
      e.preventDefault();
      changeLine(item.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var item = input.closest('.dried-minicart__item');
    if (!item) return;
    var qty = parseInt(input.value, 10);
    changeLine(item.getAttribute('data-key'), isNaN(qty) || qty < 0 ? 0 : qty);
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) close();
  });

  // the list is re-created on every render, so listen at document level
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cart-recs-list]')) syncRecsArrows();
  }, true);
  window.addEventListener('resize', syncRecsArrows);

  /* Move the drawer to <body>: rendered inside the header it would sit in that
     stacking context and the bottom toolbar would paint over it. Also drops any
     duplicate, in case the markup is rendered from more than one place. */
  function hoist() {
    var all = document.querySelectorAll('[data-cart-drawer]');
    for (var i = 1; i < all.length; i++) all[i].remove();
    var overlays = document.querySelectorAll('.dried-minicart-overlay');
    for (var j = 1; j < overlays.length; j++) overlays[j].remove();

    var d = drawer(), o = overlay();
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
    if (o && o.parentNode !== document.body) document.body.insertBefore(o, d);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoist);
  } else {
    hoist();
  }
  document.addEventListener('shopify:section:load', hoist);
})();
